import omit from 'lodash/omit';
import unzip from 'lodash/unzip';

import React from 'react';
import PropTypes from 'prop-types';

import {
  linearRegression,
  sampleCorrelation
} from 'simple-statistics';

import SummaryComponent from './Component';

const SummaryContainer = props => {
  const lrCoefficients = linearRegression(props.dots);

  const slope = lrCoefficients.m;
  const intercept = lrCoefficients.b;

  const correlation = props.dots.length >= 2 ? sampleCorrelation(
    ...unzip(props.dots)
  ) : 'N/A';

  const numberOfSamples = props.dots.length;

  return (
    <SummaryComponent
      slope={slope}
      intercept={intercept}
      correlation={correlation}
      numberOfSamples={numberOfSamples}

      {...omit(props, 'dots')}
    />
  );
};

SummaryContainer.propTypes = {
  dots: PropTypes.array.isRequired
};

export default SummaryContainer;
